module.exports = __webpack_public_path__ + "img/p3.8864dece.png";